import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  MARKET_TABS,
  MarketTabs,
  useMarketAssets,
  type MarketTab,
} from '@/widgets/market-assets';
import { TableSkeleton } from '@/shared/components/ui/TableSkeleton';
import { SEARCH_TAB_TRIGGER_CLASSNAME } from '../../config/styles';
import { SearchScrollList } from '../SearchScrollList';
import { SearchMarketRow } from './SearchMarketRow';
import { SearchMoreButton } from './SearchMoreButton';

const DEFAULT_TABLE_SKELETON = { columns: 2, rows: 5 };

type Props = {
  onClose: () => void;
};

const SearchMarketsTabs = ({ onClose }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<MarketTab>(MARKET_TABS.popular);
  const { assets, baseAsset, isLoading } = useMarketAssets(activeTab);

  return (
    <div className="flex min-h-0 grow flex-col gap-[0.8rem]">
      <MarketTabs
        value={activeTab}
        onValueChange={setActiveTab}
        triggerClassName={SEARCH_TAB_TRIGGER_CLASSNAME}
      />

      <div className="flex min-h-0 grow flex-col">
        {isLoading ? (
          <TableSkeleton {...DEFAULT_TABLE_SKELETON} />
        ) : (
          <SearchScrollList className="flex-1">
            {assets.map(asset => (
              <SearchMarketRow
                key={asset.code}
                asset={asset}
                baseAsset={baseAsset}
              />
            ))}
          </SearchScrollList>
        )}

        <SearchMoreButton
          onClick={() => {
            onClose();
            navigate('/markets');
          }}>
          {t('personalAccount.globalSearch.allAssets')}
        </SearchMoreButton>
      </div>
    </div>
  );
};

export { SearchMarketsTabs };
